import { useContext } from 'react';
//
import { TemplatesContext } from '../context/TemplatesContext';
// ----------------------------------------------------------------------

export const useTemplatesContext = () => {
  const context = useContext(TemplatesContext);

  if (!context)
    throw new Error(
      'useTemplatesContext context must be use inside TemplatesProvider',
    );

  return context;
};
